import React, { useCallback } from 'react';
import { ComplexValue } from 'app/types-shared';
import { SubscriptionsTableProps } from './types';
import { SubscriptionTiles } from 'app/area/user-profile/subscriptions/subscriptions-panel/subscriptions-container/subscription-tiles';
import { mapUniqueOptions } from 'app/area/user-profile/subscriptions/subscriptions-panel/mappers';

export const SubscriptionsContainer: React.FC<SubscriptionsTableProps> = ({
  subscribedText, optionsCodes, valueItems = [], label, locale, validation, translation, onChange
}) => {

  const uniqueOptions = mapUniqueOptions(optionsCodes);

  const changeHandler = useCallback((values: ComplexValue<number>[]) => {
    onChange(values);
  }, [uniqueOptions, valueItems, onChange]);

  const shouldShowTiles = (Array.isArray(uniqueOptions) && uniqueOptions.length > 0)
    || (Array.isArray(valueItems) && valueItems.length > 0);

  return <div className="row">
    <div className="col-md-12">
      {shouldShowTiles &&
        <SubscriptionTiles
          componentId={'subscriptions'}
          optionsCodes={optionsCodes?.values}
          options={uniqueOptions}
          valueItems={valueItems}
          translation={translation}
          locale={locale}
          validation={validation}
          onChange={changeHandler}
          label={label}
          subscribedText={subscribedText} />}
    </div>
  </div>;
};
